<template>
  <div class="hidden lg:block relative w-full h-full px-9">
    <div class="overflow-hidden w-full">
      <div
        class="flex gap-4 transition-transform duration-500 ease-in-out"
        :style="carouselStyle"
      >
        <div
          v-for="(item, index) in items"
          :key="index"
          class="product-groups-slider__item flex"
          :class="itemClass"
        >
          <ProductGroupsItem
            :item="item"
            :text-color="textColor"
            :background-color="backgroundColor"
          />
        </div>
      </div>
    </div>
    <div>
      <button
        v-if="shouldShowPrevArrow"
        :class="arrowClasses"
        class="rounded-l-lg"
        @click="prevSlide"
      >
        <span class="iconify svg--chevron-left" />
      </button>
      <button
        v-if="shouldShowNextArrow"
        :class="arrowClasses"
        class="right-9 rounded-r-lg"
        @click="nextSlide"
      >
        <span class="iconify svg--chevron-right" />
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import ProductGroupsItem from './ProductGroupsItem.vue';
import type { ProductGroupsItemType } from '~~/types/cms/ProductGroupsItem';
import {
  PRODUCT_GROUPS_SLIDER,
} from '~~/constants/cms';

export default defineComponent({
  name: 'ProductGroupsDesktopCarousel',
  components: {
    ProductGroupsItem,
  },
  props: {
    items: {
      type: Array as PropType<Array<ProductGroupsItemType>>,
      required: true,
    },
    textColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    backgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
  setup(props) {

    const arrowClasses = 'flex items-center justify-center absolute top-1/2 ' +
    '-translate-y-1/2 w-9 h-9 bg-EXPONDO-white border border-EXPONDO-grey-20';
    const currentSlide = ref(0);
    const itemsPerSlide = PRODUCT_GROUPS_SLIDER.MAX_VISIBLE_ITEMS;
    const maxSlides = computed(() => Math.ceil(props.items.length / itemsPerSlide));
    const hasMoreThanMaxPerSlide = computed(() => props.items.length > itemsPerSlide);

    const itemClass = computed(() => {

      if (props.items.length >= PRODUCT_GROUPS_SLIDER.MIN_ITEMS &&
      props.items.length <= PRODUCT_GROUPS_SLIDER.MAX_VISIBLE_ITEMS) {

        return 'flex-1';
      
      } else {

        return 'flex-none';
      
      }
    
    });

    const carouselStyle = computed(() => {

      return {
        transform: `translateX(-${currentSlide.value * 100}%)`,
      };
    
    });

    const shouldShowNextArrow = computed(() => {

      return hasMoreThanMaxPerSlide.value && currentSlide.value < maxSlides.value - 1;
    
    });
    const nextSlide = () => {

      if (currentSlide.value < maxSlides.value - 1) {

        currentSlide.value += 1;
      
      }
    
    };

    const shouldShowPrevArrow = computed(() => {

      return hasMoreThanMaxPerSlide.value && currentSlide.value > 0;
    
    });

    const prevSlide = () => {

      if (currentSlide.value > 0) {

        currentSlide.value -= 1;
      
      }
    
    };

    return {
      currentSlide,
      hasMoreThanMaxPerSlide,
      itemClass,
      carouselStyle,
      maxSlides,
      nextSlide,
      prevSlide,
      arrowClasses,
      shouldShowNextArrow,
      shouldShowPrevArrow,
    };
  
  },
});
</script>
